// Premissas do sistema.

import { CombKitLimiteInversor } from './comb-kit-limite-inversor';
import { VersaoApiImposto, OrdenacaoPadraoOrcPed, TipoCalculoMarkup, TipoFiltroProduto, OrigemGI } from './enum';

// Acessíveis para todos os usuários mas somente o `Suporte` poderá alterá-las
export class PremissasSistema {
  // A ordem da etapa do pedido que será permitido a geração do recebimento pelo gateway.
  public ordemEtapasGeracaoRecebimento: number[];

  // Aprova o recebimento (`Pagamento Aprovado`) ao receber a ação de confirmação por webhook.
  public aprovarRecebimentoPorWebhook: boolean;

  // Habilita uso da loja de produtos
  public usarLojaProdutos: boolean;

  // Ips para liberar acesso a api ERP
  public ipsLiberadosApiErp: string[];

  // Habilita a obrigatoriedade dos campos celular e email no cadastro de venda direta
  public celularEmailObgVendaDireta: boolean;

  // Habilita a obrigatoriedade dos campos nome e telefone do responsável do recebimento ao validar pedido
  public nomeTelResponsavelObgPedido: boolean;

  // Habilita somente administrador para excluir anexo de pedido
  public somenteAdmExcluiAnexoPedido: boolean;

  // Habilita a validação da venda programada no orçamento
  public validarVendaProgramadaOrcamento: boolean;

  // Habilita obrigatoriedade de seleção do tipo de inversor no montar-kit
  public obrigaSelecionarInversorMontarKit: boolean;

  // Habilita a estrutura calhetão
  public usarEstruturaCalhetao: boolean;

  // Define o texto da estrutura calhetão
  public textoEstruturaCalhetao: boolean;

  // Habilita a estrutura carport
  public usarEstruturaCarport: boolean;

  // Define o texto da estrutura carport
  public textoEstruturaCarport: string;

  // Habilita a exibição da data de disponibilidade do lote na listagem de produtos na edição de orçamento/pedido
  public exibirDataDisponibilidadeLote: boolean;

  // Habilita a exibição do lembrete de montar kit vertys
  public exibirLembreteMontarKitVertys: boolean;

  // Habilita o preenchimento automático dos campos telefone e e-mail ao consultar cnpj
  public preencherTelefoneEmailConsultaCnpj: boolean;

  // Habilita a integração RZK (acessoenergia.com.br)
  public integracaoRZK: boolean;

  // Habilita o controle de solicitação de token para integradores
  public controleSolicitacaoTokenIntegrador: boolean;

  // Bloqueia a alteração de endereço na tela Cadastrar Novo Endereço de Entrega para CNPJ.
  // Desse modo o endereço será sempre o retornado pela Receita Federal.
  public bloquearAlteracaoNovoEnderecoEntregaCNPJ: boolean;

  // Bloqueia Rua e Bairro do endereço de entrega personalizado após a consulta do CEP.
  // Campos que a consulta não trouxer (CEP genérico) ou consulta com falha ficam liberados.
  public bloquearEdicaoCamposEnderecoEntrega: boolean;

  // Habilita a etapa Aguardando Conferência dentro do monitor de Triagem.
  public exibirEtapaAguardandoConferenciaTriagem: boolean;

  // Habilita aplicar desconto ou acréscimo ao kit quando alterar o valor de algum item da composição
  public aplicarDescAcresKitQuandoAlterarPrecoComposicao: boolean;

  // Tipo de endereço de entrega padrão para orçamentos/pedidos
  // 0: Nenhum, 1: Integrador, 2: Venda Direta, 3: Automático (com base no endereço de instalação)
  public tipoEnderecoEntregaPadrao: number;

  // Habilita feed de integradores
  public feedDeIntegradores: boolean;

  // Habilita a precificação por UF
  public usarPrecificacaoPorUF: boolean;

  // Habilita a venda programada calcular o estoque automaticamente
  public vendaProgramadaAutomatica: boolean;

  // Habilita a criação e uso de Modalidades no frete
  public usarModalidade: boolean;

  // Habilita a utilização do Repasse no Menu Avulso
  public usarRemessaMenuAvulso: boolean;

  // Habilita o Frete Individual no Serviço
  public usarFreteIndividualServico: boolean;

  // Limpa cupom de desconto se alterar cidade de entrega
  public limparCupomDescontoAoAlterarCidadeEntrega: boolean;

  // Habilita a utilização de filas de tarefas
  public usarFilasTarefas: boolean;

  // Habilita a análise de desconto
  public usarAnaliseDeDesconto: boolean;

  // Habilitar confirmação do termo de aceite quando for finalizar o pedido
  public habilitarConfTermoAceiteFinalizarPedido: boolean;

  // Tipo Cálculo Markup 0 - Simples | 1 - Composto
  public tipoCalculoMarkup: TipoCalculoMarkup;

  // Permite a visualização do novo menu de kit pronto
  public usarNovoMenuKitPronto: boolean;

  // Permite a visualização do novo menu de kit plus 2
  public usarKitPlus2: boolean;

  // Permite a criação e visualização das notas fiscais da ocorrência
  public verNotasFiscaisOcorrencia: boolean;

  //Permitir vincular classificação do integrador apenas via API
  public vinculoClassificacaoPorApi: boolean;

  // Mostrar o menu avulso somente para vendedores
  public avulsoSomenteInterno: boolean;

  // Habilitar descarga CIF
  public usaDescargaCif: boolean;

  // Mostrar opção pra montar kit com ou sem stringbox
  public comSemStringBox: boolean;

  // Valor padrão pra opção pra montar kit com ou sem stringbox
  public comSemStringBoxPadrao: boolean;

  // Tipo de rastreamento [0: Nenhum, 1: Interno, 2: Externo]
  public tipoRastreamento: number;

  // url do rastreamento externo
  public urlRastreamentoExterno: string;

  // Usar agrupamento de stringbox
  public usarAgrupamentoStringbox: boolean;

  // Habilitar conversa na notificação
  public habilitarConversaNotificacao: boolean;

  // Mostrar o detalhamento de custo
  public mostrarDetalhamentoCusto: boolean;

  // Habilitar a alteração do valor do pedido pela API
  public habilitarAlteracaoValorPedidoApi: number;

  // Configuração de limites de inversores na combinação de kits
  public combKitLimiteInversor: CombKitLimiteInversor;

  // Habilitar CD por Cidade
  public habilitarCDPorCidade: boolean;

  // Atualiza cadastro venda direta automaticamente
  public atualizaCadastroVendaDiretaAutomaticamente: boolean;

  // Usar IPI separado do preco do produto
  public usarIPISeparado: boolean;

  // Alíquota CBS Global
  public aliqCbsGlobal: number;

  // Alíquota IBS Global
  public aliqIbsGlobal: number;

  // Habilita a etapa Em Importacao
  public habilitarEtapaEmImportacao: boolean;

  // Usar o monitor de conferência no modo fila de tarefa
  public usarMonitorConferenciaFilaTarefa: boolean;

  // Habilita a etapa Aguardando Conferência Pagamento
  public habilitarEtapaAguardandoConferenciaPagamento: boolean;

  // Habilitar Frete por Peso
  public habilitarFretePorPeso: boolean;

  // Habilita os menus 'montar kit' e 'kit pronto'
  public habilitarMenuSolar: boolean;

  // Habilita Api de Imposto
  public habilitarApiImposto: boolean;

  // Calcular impostos do orçamento sob demanda
  public calcularImpostosSobDemanda: boolean = false;

  // Versão da Api de Imposto
  public versaoApiImposto: VersaoApiImposto;

  // Url da Api de Imposto
  public urlApiImposto: string;

  // Token da Api de Imposto
  public tokenApiImposto: string;

  // Reaproveita a última resposta de sucesso da Api de Imposto para a mesma requisição
  public usarResultadoGuardadoApiImposto: boolean;

  // Idade máxima (minutos) da resposta guardada que pode ser reaproveitada
  public idadeMaximaResultadoApiImpostoMinutos: number;

  // Tempo limite (segundos) da chamada à Api de Imposto (V1 e V2)
  public tempoLimiteApiImpostoSegundos: number;

  // Habilita Validação Localizacao
  public habilitaValidacaoLocalizacao: boolean;

  // Habilita a precificação por integrador
  public habilitarPrecificacaoPorIntegrador: boolean;

  // Habilita a adição de itens via planilha na Loja de Produtos
  public adicionarItensPorPlanilhaLojaDeProduto: boolean;

  // Habilita o Lote de Produtos (produtoLote)
  public usaProdutoLote: boolean;

  // Exclui cupom de desconto ao mudar localização
  public excluirCupomDescontoAoMudarLocalizacao: boolean;

  // Filtro de produtos por agrupamento (0) ou por categoria (1)
  public filtroProduto: TipoFiltroProduto;

  // Ordenação padrão na tela de orçamentos/pedidos
  public ordenacaoPadraoOrcPed: OrdenacaoPadraoOrcPed;

  // Recalcula frete manual
  public recalculaFreteManual: boolean;

  // Habilita tela de Orçamentos
  public habilitaOrcamento: boolean;

  // Excluir cupom de desconto ao mudar tipo de frete
  public excluirCupomDescontoAoMudarTipoFrete: boolean;

  // Excluir cupom de desconto ao mudar o tipo de frete cif
  public excluirCupomDescontoAoMudarTipoFreteCif: boolean;

  // Habilita a não validação do pedido (ativa a etapa Editando)
  public naoValidarPedido: boolean;

  // Origens para não validar o pedido caso a premissa estiver ativa
  public origensParaNaoValidarPedido: OrigemGI[];

  // Atualizar preço de custo dos produtos ao clonar orc/ped
  public atualizarCustoProdutoAoClonar: boolean;

  // Manter desconto/cupom fixo nas edições
  public manterCupomDesconto: boolean;

  // Habilita os menus 'montar kit'
  public habilitaMenuMontarKit: boolean;

  // Habilita os menus 'kit pronto'
  public habilitaMenuKitPronto: boolean;

  // Habilita a api de estoque
  public habilitaApiEstoque: boolean;

  // Define a quantidade máxima de forma de pagamento quando utilizar multi formas
  public qtdMaxFormPag: number;

  // Aplicar ou não desconto de condição de pagamento quando tiver mais de uma forma de pagamento
  public aplicarDescontoCondPagMulti: boolean;

  // Excluir cupom de desconto ao mudar valor do frete
  public excluirCupomDescontoAoMudarValorFrete: boolean;

  // Tornar Celular e E-mail obrigatórios ao cadastrar novo endereço de entrega
  public celularEmailObgNovoEnderecoEntrega: boolean;

  // Mostrar endereço de entrega se for FOB
  public mostrarEnderecoEntregaFob: boolean;

  // Colirir o fundo da topbar da tela de edição de orçamento/pedido
  public colorirFundoTopBarEdicao: boolean;

  // Mostrar colunas adicionais de preço unitário
  public mostrarColunasAdicionaisPreco: boolean;
}
